import Dialog from "@material-ui/core/Dialog";
import AlertDialog from "components/Dialog";
import MainTabs from "components/mainTabs/MainTabs";
import NotAuthorized from "components/NotAuthorized/index";
import { getUrlTab, useUrlTab } from "hook/useUrlTab";
import { SubHeader } from "layout/SubHeader";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { setCampaignEditData, setCardContent, setCreateCampaignDialog, setSelectedAudienceRows, setSelectedTemplate } from "services/api/communication";
import { Audience } from "./Components/Audience/Audience";
import { Automation } from "./Components/Automation/Automation";
import { Campaigns } from "./Components/Campaigns/Campaigns";
import { CreateCampaign } from "./Components/Campaigns/CreateCampaign/CreateCampaign";
import { Templates } from "./Components/Templates/Templates";
import { Contant } from "./Theme";


const tabOptions = [
  {
    title: "Audiences",
    value: "Audiences",
    width: "150px",
  },
  {
    title: "Campaigns",
    value: "Campaigns",
    width: "150px",
  },
  {
    title: "Templates",
    value: "Templates",
    width: "150px",
  },
  {
    title: "Automation",
    value: "Automation",
    width: "150px",
  }
]

const Communication = () => {
  const dispatch = useDispatch();

  const history = useHistory();
  const { search,pathname  } = useLocation();
  const searchParams = new URLSearchParams(search);
	const tabParam = searchParams.get("tab"); 
	const campaignIdParam = searchParams.get("campaignId"); 
  const cardContent = useSelector((state) => state.communication.cardContent);

  const { createCampainOpenDialog } = useSelector(
    (state) => state.communication
  );

  // ?tab= picks the tab (any letter case); an unknown value opens Audiences instead of falling through to Automation
  const tabValues = tabOptions.map((tab) => tab.value);
  const [toggle, setToggle] = useState(getUrlTab(search, tabValues) || "Audiences");
  // also when the page is already open (e.g. a tab picked from the global search)
  useUrlTab(setToggle, tabValues);
  const [isCommunicationActive, setIsCommunicationActive] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const handleClick = (tab) => {
    setToggle(tab?.value);
    resetSearchParams();
  };
  
  let orgInfo = localStorage?.getItem("organization")
  ? JSON.parse(localStorage?.getItem("organization"))
  : [];

  let authorizedModulesInfo = localStorage?.getItem("authorizedModules")
  ? JSON.parse(localStorage?.getItem("authorizedModules"))
  : [];

  const resetSearchParams = () => {
    history.push({
      pathname,
      search: '', 
    });
  }

  useEffect(() => {
    const status =
      orgInfo?.authorizedModules?.find(
        (item) => item?.moduleName === "communication"
      )?.active === true &&
      authorizedModulesInfo?.find((item) => item?.moduleName === "communication")
        ?.active === true
        ? true
        : false;

        setIsCommunicationActive(status);
  }, []);


  const checkNotAuthorized = () => {
    if (!isCommunicationActive) {
      return <NotAuthorized title={"Communications"} />;
    }
  };


  const closeModal = () => {
    if (cardContent === "Done") {
      return confirmCloseHandler();
    }
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    dispatch(setCreateCampaignDialog(false));
    dispatch(setCardContent(""));
    dispatch(setSelectedAudienceRows([]));
    dispatch(setSelectedTemplate({}));
    dispatch(setCampaignEditData({}));
    
  }
  
  return (
    <div className="pt-10 pb-10 w-100">
      <div className="d-flex justify-content-between align-items-center subHeader">
        <SubHeader
          className="subheader"
          {...{
            title: "Communications",
            color: "#2455EF",
          }}
        />
      </div>
      <MainTabs 
        className={"mt-5"}
        tabs={tabOptions}
        activeTab={toggle}
        onTabsChange={handleClick}
      />
      {/* <div className="toggle-bar mt-5">
        {tabOptions.map(
          (tab, i) =>
            (
              <p
                className={
                  toggle === tab
                    ? "selected tab-title w-150px"
                    : "unselected tab-title w-150px"
                }
                onClick={() => handleClick(tab)}
              >
                {tab}
              </p>
            )
        )}
      </div> */}
      <Contant>
        {toggle === "Audiences" ? (
          checkNotAuthorized() || <Audience setToggle={setToggle} />
        ) : toggle === "Campaigns" ? (
          checkNotAuthorized() || <Campaigns setToggle={setToggle} campaignIdParam={campaignIdParam} resetSearchParams={resetSearchParams}/>
        ) : toggle === "Templates" ? (
          <Templates setToggle={setToggle}/>
        ) : (
          checkNotAuthorized() || <Automation setToggle={setToggle}/>
        )}
      </Contant>
      {/* Create Campaign Modal */}
      <Dialog
        open={createCampainOpenDialog}
        onClose={closeModal}
        sx={{ width: "1500px" }}
        PaperProps={{
          style: {
            width: "1500px",
            overflowX: "hidden",
            borderRadius: "10px",
            marginButton: "20px",
          },
        }}
        fullWidth
        maxWidth={"lg"}
      >
        <CreateCampaign setToggle={setToggle} onClose={closeModal} />
      </Dialog>
      <AlertDialog
        open={confirmClose}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </div>
  );
};

export default Communication;
